import { createFeatureSelector } from '@ngrx/store';
import {
  ApplianceDetailsState,
  APPLIANCE_DETAILS_FEATURE_KEY,
} from './appliance-details.reducer';

export const getApplianceDetailsState =
  createFeatureSelector<ApplianceDetailsState>(APPLIANCE_DETAILS_FEATURE_KEY);
